<div class="flex justify-center items-center h-full text-center pt-8 md:pt-0">
  <div>
    <div
      class="bg-white border border-gray-200 rounded-2xl flex items-center justify-center w-[110px] h-[110px] m-auto mb-4"
    >
      <img
        src="/assets/img/logo_trimmed.png"
        class="max-w-[90px] m-auto"
        alt="Prefund"
      />
    </div>
    <div class="mb-2">
      <span class="block text-lg font-bold mb-4">Prefund</span>

      <span class="block"
        ><span class="capitalize">{{ env.environment.name }}</span> Build
        {{ version }}-{{ commitHash }}</span
      >
      <span class="block">Designed and developed by</span>
      <span class="block">Gábor Pintér</span>
    </div>
    <!-- <ul class="mb-2">
      <li class="underline text-[var(--primary-color)]">
        <a href="{{ env.environment.urls.feedback }}" target="_blank"
          >Feedback</a
        >
      </li>
      <li class="underline text-[var(--primary-color)]">
        <a href="{{ env.environment.urls.roadmap }}" target="_blank">Roadmap</a>
      </li>
      <li class="underline text-[var(--primary-color)]">
        <a href="{{ env.environment.urls.blog }}" target="_blank">Blog</a>
      </li>
      <li class="underline text-[var(--primary-color)]">
        <a href="{{ env.environment.urls.newsletter }}" target="_blank"
          >Newsletter</a
        >
      </li>
    </ul>
    <ul class="mb-2">
      <li class="underline">
        <a href="{{ env.environment.urls.terms }}" target="_blank"
          >Terms of service</a
        >
      </li>
      <li class="underline">
        <a href="{{ env.environment.urls.privacy }}" target="_blank">Privacy</a>
      </li>
    </ul> -->
  </div>
</div>
